// General settings tab — owns the single query that feeds all three cards and
// the loading/error/content triad. One GET returns the company profile plus its
// formats (nested as `formatSettings`); each card then saves its own section.

import { useTranslation } from 'react-i18next';
import CompanyDetailsCard from './CompanyDetailsCard';
import DeleteCompanyCard from './DeleteCompanyCard';
import FormatsCard from './FormatsCard';
import { Button, Icon } from '@/components/common';
import { useGetCompanySettingsQuery } from '@/api/endpoints/companySettingsApi';

const GeneralSettingsTab = () => {
  const { t } = useTranslation();
  const { data: settings, isFetching, isError, refetch } = useGetCompanySettingsQuery();

  if (isFetching && !settings) {
    return (
      <div className='company-settings__status'>
        <span className='company-settings__spinner' aria-hidden='true' />
        <p className='company-settings__status-text'>{t('text_loading')}</p>
      </div>
    );
  }

  // A failed fetch leaves `settings` undefined with isFetching false — without
  // this the tab would render blank.
  if (isError || !settings) {
    return (
      <div className='company-settings__status'>
        <Icon name='circle-alert' size={28} />
        <p className='company-settings__status-text'>{t('company_settings_load_error')}</p>
        <Button variant='secondary' iconStart='rotate-cw' onClick={() => void refetch()}>
          {t('forms_builder_retry')}
        </Button>
      </div>
    );
  }

  return (
    <div className='company-settings__column'>
      <CompanyDetailsCard details={settings} />
      <FormatsCard formats={settings.formats} />
      <DeleteCompanyCard />
    </div>
  );
};

export default GeneralSettingsTab;
